import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import ImgButton from '../foundation/ImgButton'
import startAltBtn from '../images/start-alt-btn.png'
import startAltBtnHighlight from '../images/start-alt-btn-highlight.png'

export default class StartAltBtn extends Component {
  /**
   * Render the component
   * @returns
   */
  render () {
    return (
      <Link to='/calculator/0'>
        <ImgButton
          imgSrc={startAltBtn}
          mouseOverSrc={startAltBtnHighlight}
          altText='Start Button'
          btnStyle={this.props.btnStyle}
        />
      </Link>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/landing-elements/StartAltBtn.js